module.exports = __webpack_public_path__ + "img/term_plus_logo.cdab6b2b.webp";